import React from 'react';
import { Text } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import AddInsuranceModalNavigationItem from './AddInsuranceModalNavigationItem';
import { Coverage } from '../../../../../../../types/AdvisoryReport';
import NavigationSection from './NavigationSection';
import { Page } from '../../../hooks/useInsurancePolicyModal';
import { groupBy } from 'lodash';
import useAddInsuranceModalContext from '../../../hooks/useAddInsuranceModalContext';

interface Props {
  page: Page;
  coverages: Coverage[];
  onClick: (i: number) => void;
  onRemove: (ids: string[]) => void;
}

const AddInsuranceModalNavigationCoverages: React.FC<Props> = ({
  coverages,
  page,
  onClick,
  onRemove,
}) => {
  const { t } = useTranslation();
  const { riskObjects, setRiskObjects } = useAddInsuranceModalContext();
  const coveragesByRisk = groupBy(coverages, 'risk_object');

  const handleRemove = (risk: string) => {
    onRemove(coveragesByRisk[risk]?.map(({ id }) => id) || []);

    const filteredRisks = riskObjects.filter(({ label }) => label !== risk);
    setRiskObjects(filteredRisks);
  };

  return (
    <NavigationSection title={t('RISKS')}>
      {!riskObjects.length && (
        <Text color="gray.500">
          {t(
            'ADVISORY-REPORTS_CREATION-FLOW_CURRENT-INSURANCE_MODAL_EMPTY-COVERAGES',
          )}
        </Text>
      )}
      {riskObjects.map(({ label, value }, index) => {
        const isActive = page.index === index;

        return (
          <AddInsuranceModalNavigationItem
            key={value}
            isActive={isActive}
            onClick={() => onClick(index)}
            {...(coverages.length && { onRemove: () => handleRemove(label!) })}
          >
            {label}
          </AddInsuranceModalNavigationItem>
        );
      })}
    </NavigationSection>
  );
};

export default AddInsuranceModalNavigationCoverages;
